/**
 * Perform discrete operations synchronously and in order. You can observe
 * the <code>busy</code> an <code>idle</code> events to be notified when 
 * the queue enters or leaves a busy state.
 * @constructor
 * @extends {Foundation.Observable}
 */
Foundation.Promise.Queue = function () {
    Foundation.Observable.call(this);
    
    /**
     * Array to store the queue of operation functions.
     * @private
     * @type {Array.<Foundation.Promise.Queue.Operation>}
     */
    this.operations = [];
};
Foundation.inherit(Foundation.Promise.Queue, Foundation.Observable);

/**
 * An operation is a function that always returns a promise.
 * @typedef {function():!Foundation.Promise}
 */
Foundation.Promise.Queue.Operation;

/**
 * Execute an operation, immediately if nothing is running on the queue,
 * or later if some other operation is currently being executed.
 * @param {Foundation.Promise.Queue.Operation} op
 */
Foundation.Promise.Queue.prototype.performOperation = function (op) {
    this.fire("busy");
    this.operations.push(op);
    if (this.operations.length === 1) {
        op().always(this.performNextOperation.bind(this));
    }
};

/**
 * Run the next operation. Called when the previously running operation's
 * promise is fulfilled.
 * @private
 */
Foundation.Promise.Queue.prototype.performNextOperation = function () {
    this.operations.shift();
    if (this.operations.length) {
        this.operations[0]().always(this.performNextOperation.bind(this));
    }
    else {
        this.fire("idle")
    }
};

